export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "Pakilagay ang iyong sagot dito",
      conversationalPlaceholder: "Pakilagay ang iyong sagot dito",
      conversationClosed: "Sarado na ang usapan.",
      conversationalDisclaimer: "Ang mga follow-up na tanong ay bubuo ng AI batay sa iyong mga sagot."
    },
    openText: {
      openEndPlaceholder: "Pakilagay ang iyong sagot dito"
    },
    multiText: {
      fieldPlaceholder: 'Sagot {number}',
      instruction: 'Mag-type ng hindi bababa sa {count} sagot sa ibaba, isa bawat text box',
      instructionWithoutMinimum: 'I-type ang iyong mga sagot sa ibaba, isa bawat text box',
      minimumEntries: 'Mangyaring maglagay ng hindi bababa sa {count} sagot para magpatuloy.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Brand {number}',
        minimumEntries: 'Mangyaring maglagay ng hindi bababa sa {count} brand para magpatuloy.'
      }
    },
    multiselect: {
      caption: "Pumili ng lahat ng naaangkop"
    },
    rankOrder: {
      enterRankOrder: "Ilagay ang Pagkakasunod-sunod",
      placeholder: "I-drag ang iyong mga pinili dito para i-ranggo"
    },
    openNumeric: {
      label: "Bukas na Numeriko"
    },
    complete: {
      message: "Salamat sa pagsagot ng survey na ito."
    },
    openVideo: {
      warning: "Mangyaring mag-record ng video bago magpatuloy.",
      uploadStatusUploading: "Mangyaring maghintay hanggang matapos naming iproseso ang iyong video bago magpatuloy...",
      uploadStatusSuccess: "Matagumpay ang pag-upload, maaari ka nang magpatuloy.",
      uploadStatusError: "Hindi natapos ang pag-upload, subukan muli."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Mangyaring maglagay ng wastong email',
      text_invalid_phone: 'Mangyaring maglagay ng wastong numero ng telepono',
      text_invalid_us_zip: 'Mangyaring maglagay ng wastong US zip code',
      text_invalid_ca_postal: 'Mangyaring maglagay ng wastong postal code ng Canada',
      text_invalid_uk_postal: 'Mangyaring maglagay ng wastong postal code ng UK',
      text_invalid_custom: 'Mangyaring maglagay ng wastong {fieldName}',
      text_min_chars: 'Mangyaring maglagay ng hindi bababa sa {min} na character',
      text_max_chars: 'Mangyaring huwag maglagay ng higit sa {max} na character',
      text_alpha_not_allowed: 'Mga numero lamang ang pinapayagan',
      text_numeric_not_allowed: 'Mga titik lamang ang pinapayagan'
    },
    external: {
      invalid: 'Hindi balido ang sagot sa tanong na ito.',
      required: 'Dapat sagutin ang tanong.',
      singlechoice_required: 'Mangyaring pumili ng isang opsyon bago magpatuloy.',
      numeric_required: 'Mangyaring pumili ng isang rating bago magpatuloy.',
      text_required: 'Mangyaring maglagay ng isang sagot bago magpatuloy.',
      bigtext_required: 'Mangyaring maglagay ng isang sagot bago magpatuloy.',
      singlechoiceother_incomplete: 'Mangyaring maglagay ng isang sagot bago magpatuloy.',
      multiselectother_incomplete: 'Mangyaring maglagay ng isang sagot bago magpatuloy.',
      numeric_invalid: 'Mangyaring maglagay ng wastong numero bago magpatuloy.',
      radiogrid_required: 'Mangyaring pumili ng isang opsyon para sa bawat row bago magpatuloy.',
      incomplete: 'Mangyaring ganap na tapusin ang tanong na ito bago magpatuloy.',
      multiselect_min: 'Mangyaring pumili ng hindi bababa sa {value} mga opsyon bago magpatuloy.',
      multiselect_max: 'Mangyaring pumili ng hindi hihigit sa {value} mga opsyon bago magpatuloy.',
      multiselectother_min: 'Mangyaring pumili ng hindi bababa sa {value} mga opsyon bago magpatuloy.',
      multiselectother_max: 'Mangyaring pumili ng hindi hihigit sa {value} mga opsyon bago magpatuloy.',
      multiselectgrid_min: 'Mangyaring pumili ng hindi bababa sa {value} na opsyon para sa bawat row bago magpatuloy.',
      multiselectgrid_max: 'Mangyaring pumili ng hindi hihigit sa {value} mga opsyon para sa bawat row bago magpatuloy.',
      rankorder_min: 'Mangyaring ranggo ang hindi bababa sa {value} mga item bago magpatuloy.',
      rankorder_max: 'Mangyaring ranggo ang hindi hihigit sa {value} mga item bago magpatuloy.'
    }
  }
}
